import DownloadIcon from '@mui/icons-material/Download'
import SensorsIcon from '@mui/icons-material/Sensors'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import moment from 'moment'
import { useTranslation } from 'react-i18next'

import { Button } from '~/components/Atoms/Button'
import { downloadFile } from '~/utils/utilityFunctions'

import ReactGA from '~/lib/analytics'
import { useWebinars } from '~/lib/company'

import 'moment/dist/locale/fr'

export function EventCard() {
  const theme = useTheme()
  const { t } = useTranslation()
  moment.locale('fr')
  const { data } = useWebinars()
  return (
    <Box
      display="flex"
      bgcolor={theme.palette.common.white}
      padding={`${theme.spacing.L} ${theme.spacing.XXL}`}
      borderRadius={theme.radius.M}
    >
      <Box display="flex" flexDirection="column" gap={theme.spacing.L} width="100%">
        <Box display="flex" alignItems="center" gap={theme.spacing.S}>
          <Typography variant="body-small">{t('home:event.title', { count: data?.length ?? 0 })}</Typography>
          {data && data.length > 0 && (
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              bgcolor={theme.palette.primary.main}
              color={theme.palette.text.inverse}
              borderRadius="50%"
              height={theme.size[8]}
              width={theme.size[8]}
            >
              <Typography variant="body-small">{data.length}</Typography>
            </Box>
          )}
        </Box>
        <Box display="flex" flexDirection="column" gap={theme.spacing.L} sx={{ maxHeight: '300px', overflowY: 'auto' }}>
          {data?.map((webinar) => (
            <Box
              key={webinar.uuid}
              display="flex"
              flexDirection="column"
              borderRadius={theme.radius.M}
              padding={theme.spacing.L}
              gap={theme.spacing.L}
              bgcolor={theme.palette.primary.lightest}
              width="100%"
            >
              <Box display="flex" gap={theme.spacing.L}>
                <Box
                  display="flex"
                  borderRadius={theme.spacing.S}
                  bgcolor={theme.palette.primary.hover}
                  padding={theme.spacing.M}
                  color={theme.palette.text.inverse}
                  height={theme.size[14]}
                  width={theme.size[14]}
                  justifyContent="center"
                  alignItems="center"
                >
                  <SensorsIcon />
                </Box>
                <Box display="flex" width="100%" flexDirection="column">
                  <Typography variant="body">{webinar.title}</Typography>
                  <Typography variant="body-small" color={theme.palette.text.mainLight}>
                    {moment(webinar.date).format('D MMMM YYYY - HH:mm')}
                  </Typography>
                </Box>
              </Box>
              <Box display="flex" gap={theme.spacing.M}>
                {webinar.subscribe_link && (
                  <Button
                    label={t('home:event.register')}
                    variant="contained"
                    href={webinar.subscribe_link}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() =>
                      ReactGA.event({ action: 'webinar_register', category: 'engagement', label: webinar.uuid })
                    }
                  />
                )}
                {webinar.file && (
                  <Button
                    label={t('home:event.downloadPoster')}
                    variant="outlined"
                    startIcon={<DownloadIcon />}
                    sx={{ whiteSpace: 'nowrap' }}
                    onClick={() => {
                      ReactGA.event({ action: 'webinar_download_poster', category: 'engagement', label: webinar.uuid })
                      downloadFile(webinar.file.url, `${webinar.title}.pdf`)
                    }}
                  />
                )}
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  )
}
